import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { FooterButtonsProps } from './footerButtons.props'

export const defaultData: FooterButtonsProps = {
  buttons: [
    {
      url: '/contacts',
      label: 'Свържете се с нас',
      icon: 'phone',
    },
    {
      url: '/faq',
      label: 'Имате въпрос?',
      icon: 'chat',
    },
  ],
}

export const FooterButtonsType = ComponentTypeFactory.create<FooterButtonsProps>(
  'FooterButtons',
  {
    buttons: FieldTypeFactory.list({
      of: {
        url: FieldTypeFactory.text(),
        label: FieldTypeFactory.text(),
        icon: FieldTypeFactory.text(),
      },
    }),
  }
)
